export default "__VITE_ASSET__DfACOOo1__"